export default {
    // baseURL: "https://erp.tanfuhua.com/"+"api/",  // 使用服务器的后端
       baseURL: "https://demo.memms.backend.gnshk.com/" + "api/", // 使用本地的后端
    //baseURL: "/api/", // 部署用的后端
}